import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=9932a050&scoped=true"
import script from "./Mapa.vue?vue&type=script&lang=ts"
export * from "./Mapa.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Mapa.vue?vue&type=style&index=0&id=9932a050&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9932a050",
  null
  ,true
)

export default component.exports